import PropTypes from 'prop-types';
import React from 'react';
import HeadingStyled from './Heading.styled';

const Heading = ({
  children,
  headingSize,
  headingText,
  headingColor,
  isCentered,
  headingTag,
  onHeadingClick,
  onHeadingMiddleClick,
  style,
}) => {
  return (
    <HeadingStyled
      onClick={onHeadingClick}
      onMouseDown={onHeadingMiddleClick}
      className="heading-component"
      style={style}
      headingColor={headingColor}
      headingSize={headingSize}
      isCentered={isCentered}
    >
      {headingTag === 'h1' ? (
        <h1>
          {headingText}
          {children}
        </h1>
      ) : null}
      {headingTag === 'h2' ? (
        <h2>
          {headingText}
          {children}
        </h2>
      ) : null}
      {headingTag === 'h3' ? (
        <h3>
          {headingText}
          {children}
        </h3>
      ) : null}
      {headingTag === 'h4' ? (
        <h4>
          {headingText}
          {children}
        </h4>
      ) : null}
      {headingTag === 'h5' ? (
        <h5>
          {headingText}
          {children}
        </h5>
      ) : null}
      {headingTag === 'h6' ? (
        <h6>
          {headingText}
          {children}
        </h6>
      ) : null}
      {!headingTag ? (
        <span>
          {headingText}
          {children}
        </span>
      ) : null}
    </HeadingStyled>
  );
};

Heading.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  headingColor: PropTypes.any,
  headingSize: PropTypes.string,
  headingTag: PropTypes.string,
  headingText: PropTypes.any,
  isCentered: PropTypes.any,
  onHeadingClick: PropTypes.any,
  onHeadingMiddleClick: PropTypes.any,
  style: PropTypes.any,
};

export default Heading;
